// src/hooks/useUnreadCount.js

import { useState, useEffect } from 'react';
import { db, auth } from '../config/firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

export const useUnreadCount = (chatId) => {
  const [count, setCount] = useState(0);
  const currentUser = auth.currentUser;

  useEffect(() => {
    if (!chatId || !currentUser) return;

    const messagesRef = collection(db, 'chats', chatId, 'messages');
    // --- THIS QUERY IS NOW CORRECTED ---
    const q = query(
      messagesRef,
      where('receiverId', '==', currentUser.uid),
      where('readAt', '==', null) // Check for the new timestamp field
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      setCount(querySnapshot.size);
    });

    return () => unsubscribe();
  }, [chatId, currentUser]);

  return count;
};